<template>
  <div class="patient-header" :class="mode">
    <div>
      <div class="smd-profile-image" :class="small ? 'm' : 'l'"
           :style="patient.avatar ? 'background:url('+ patient.avatar + ')' : ''">
        <template v-if="patient.avatar == null">
          {{initials}}
        </template>
      </div>
      <div class="patient-data">
        <div class="patient-data__details">

          <label dark v-if="!small">{{patient._id ? patient._id : '0000'}}</label>

          <div class="patient-data__name">
            <h2>{{patient.firstName}} {{patient.middleName}} {{patient.lastName}}</h2>
            <smd-button icon="smd-icon-edit" @click="edit" v-if="!small"/>
          </div>

          <div class="patient-data__meta">
            <p><label>DOB:</label> {{patient.birthDate | formatDate}}</p>
            <p><label>AGE:</label> {{patient.birthDate | computeAge}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="small">
      <label v-if="title" >{{title}}</label>
    </div>
    <div class="actions">
      <div>
        <slot name="actions"/>
        <smd-btn icon="smd-icon-action-close" @click="$emit('close')"/>
      </div>
      <div v-if="!small">
        <slot name="bottomActions"/>
      </div>
    </div>
  </div>
</template>

<script>
  import SmdButton from "../../../scaffolding/smd-button";

  export default {
    name: "patient-header",
    components: {SmdButton},
    props:{
      mode: {type: String, default: 'small'},
      title: String,
      patient: null
    },
    data(){
      return{
        small: false
      }
    },
    watch:{
      'mode': function(newVal){
        this.updateMode(newVal);
      }
    },
    methods:{
      updateMode(value){
        this.small = value === 'small' ? true : false;
      },
      edit(e) {
        this.$emit('edit',e)
      }
    },
    /// TODO: Fix that patient info should be passed. Instead of getting it from the getter
    computed:{
      initials(){
        return this.patient.firstName && this.patient.lastName ? this.patient.firstName.substring(0,1) + this.patient.lastName.substring(0,1) : ' ';
      }
    },
    mounted(){
      this.updateMode(this.mode);
    }
  }
</script>

<style lang="scss">

  @import "../../../scaffolding/scss/pogs-util";

  .patient-header{
    @extend %align-items-center;
    @include make-grid-cols(repeat(2,1fr));
    @include space-me($prop: margin, $b: base);

    &:not(.small) > div:first-child{
      @include make-grid-cols(80px 1fr, space(m));
      @include space-me($t: s, $b: s);
    }


    &:not(.small) .patient-data__name{
      margin-top: -5px;
    }

    .patient-data__name{
      @extend %flex-row--center-x;

      button{
        @include space-me($prop: margin, $l: base);
      }
    }

    .actions {
      @include make-grid-rows(1fr, space(m));
      align-self: flex-start;

      & > div{
        @extend %flex, %align-self-flex-start, %justify-content-flex-end;
        min-height: 36px;

        & > *:not(:last-child){
          margin-right: space(s);
        }
      }
    }
  }

  .patient-header{
    &.small{
      grid-template-columns: repeat(3, 1fr);
      max-height: 60px;
      margin-bottom: 0;

      & > div:first-child{
        @include make-grid-cols(40px 1fr, space(m));
      }

      & > div:nth-child(2){
        @extend %flex, %justify-content-center;
        align-self: flex-end;
      }

      .actions{
        & > div{
          @extend %flex-row--center-x, %justify-content-flex-end;
        }
      }

      .patient-data__details{
        p{font-size: font(s);}

        & > div:nth-child(2){
          grid-template-columns: 150px 60px;
          padding-top: 3px;
        }
      }
    }
  }

</style>
